// src/pages/Dropdrop.jsx
import React, { useEffect, useState, useRef } from "react";
import Tabordenes from "./Tabordenes";
import Tabingresos from "./Tabingresos";

// Usa ABSOLUTAS EN HTTPS (evita mixed content y problemas de basePath)
const ENDPOINTS = [
  "https://marketbusters.pro/Dropdrop/dropdrop_pedidos_historicos.php",     // 1) primero SIEMPRE
  "https://marketbusters.pro/Dropdrop/dropdrop_cluster_ubigeo_mensual.php", // 2)
  "https://marketbusters.pro/Dropdrop/dropdrop_ganancias_mensual.php",      // 3)
  "https://marketbusters.pro/Dropdrop/dropdrop_cluster_mensual.php",        // 4)
];

export default function Dropdrop() {
  const [activeTab, setActiveTab] = useState("ordenes");
  const [lastUpdate, setLastUpdate] = useState(null);
  const [updating, setUpdating] = useState(false);
  const [message, setMessage] = useState("");
  const mountedRef = useRef(false);

  const runPhp = async (url) => {
    const bust = url.includes("?") ? "&" : "?";
    const full = `${url}${bust}t=${Date.now()}`;
    console.log("[Dropdrop] fetch:", full);
    const res = await fetch(full, {
      method: "GET",
      cache: "no-store",
      credentials: "include", // por si tu PHP requiere sesión/cookie
    });
    if (!res.ok) {
      const ct = res.headers.get("content-type") || "";
      if (ct.includes("application/json")) {
        try {
          const j = await res.json();
          throw new Error(`HTTP ${res.status} · ${j?.error || j?.message || url}`);
        } catch {
          throw new Error(`HTTP ${res.status} en ${url}`);
        }
      }
      throw new Error(`HTTP ${res.status} en ${url}`);
    }
  };

  const refreshAll = async () => {
    try {
      setUpdating(true);
      setMessage("Actualizando…");
      for (const ep of ENDPOINTS) {
        await runPhp(ep);
      }
      setMessage("✅ Actualizado OK");
    } catch (e) {
      console.error("Error actualizando PHPs:", e);
      setMessage(`❌ No pude actualizar los datos. Detalle: ${e.message}`);
      alert(`No pude actualizar los datos.\n\nDetalle: ${e.message}`);
    } finally {
      setUpdating(false);
      setLastUpdate(Date.now()); // dispara el refetch en los tabs
    }
  };

  // Ejecuta automáticamente al entrar al módulo (montaje del componente)
  useEffect(() => {
    if (mountedRef.current) return;
    mountedRef.current = true;
    refreshAll();
  }, []);

  // (Opcional) reintenta cuando la pestaña vuelve a ser visible
  useEffect(() => {
    const onVisible = () => {
      if (document.visibilityState === "visible" && !updating) {
        // refreshAll(); // descomenta si quieres refrescar al volver el foco
      }
    };
    document.addEventListener("visibilitychange", onVisible);
    return () => document.removeEventListener("visibilitychange", onVisible);
  }, [updating]);

  return (
    <div style={{ padding: 20 }}>
      <h2 style={{ color: "#f5f5f5", marginBottom: 8 }}>🛒 Panel de Dropdrop</h2>
      <div style={{ fontSize: 12, color: "#9ca3af", marginBottom: 16 }}>
        {message || "Listo"}
        {lastUpdate && <> · Última actualización: {new Date(lastUpdate).toLocaleTimeString("es-CL")}</>}
      </div>

      {/* Tabs + botón actualizar */}
      <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 16 }}>
        <button
          onClick={() => setActiveTab("ordenes")}
          style={{
            padding: "10px 16px",
            borderRadius: 8,
            border: "1px solid #3a3a3a",
            background: activeTab === "ordenes" ? "#111" : "transparent",
            color: "#f5f5f5",
            cursor: "pointer",
          }}
        >
          📦 Órdenes
        </button>

        <button
          onClick={() => setActiveTab("ingresos")}
          style={{
            padding: "10px 16px",
            borderRadius: 8,
            border: "1px solid #3a3a3a",
            background: activeTab === "ingresos" ? "#111" : "transparent",
            color: "#f5f5f5",
            cursor: "pointer",
          }}
        >
          💰 Ingresos
        </button>

        <button
          onClick={refreshAll}
          disabled={updating}
          style={{
            marginLeft: "auto",
            padding: "10px 16px",
            borderRadius: 8,
            border: "1px solid #0d6efd",
            background: "#0d6efd",
            color: "#fff",
            fontWeight: 700,
            cursor: updating ? "not-allowed" : "pointer",
            opacity: updating ? 0.7 : 1,
          }}
        >
          {updating ? "Actualizando..." : "🔄 Actualizar"}
        </button>
      </div>

      {/* Contenido */}
      {activeTab === "ordenes" && <Tabordenes lastUpdate={lastUpdate} />}
      {activeTab === "ingresos" && <Tabingresos lastUpdate={lastUpdate} />}
    </div>
  );
}
